// Configuration for Hustle Dial Landing Page
export const config = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_URL || '',
  
  // Dashboard URL
  DASHBOARD_URL: process.env.REACT_APP_DASHBOARD_URL || '/admin',
  
  // Admin Configuration
  ADMIN_PASSWORD: process.env.REACT_APP_ADMIN_PASSWORD || 'hustle2024',
  
  // Development mode
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  
  // Email validation regex
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
}; 
